import { render } from "./ToggelDesktop.vue?vue&type=template&id=751d5aaa"
import script from "./ToggelDesktop.vue?vue&type=script&lang=js"
export * from "./ToggelDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__